module.exports = __webpack_public_path__ + "img/dismiss_icon.8c3f2b6a.png";